export default __webpack_public_path__ + "static/media/Unlistedkart.36528f22.svg";